/**
 * 共享搜索区域可见性状态的 composable
 * - 首页通过滚动距离设置 isSearchBoxVisible
 * - 导航组件消费该状态，在滚动达到阈值后展开 header 搜索栏
 */
const isSearchBoxVisible = ref(true)

export const useSearchBoxVisibility = () => {
  const setVisible = (visible: boolean) => {
    isSearchBoxVisible.value = visible
  }

  return {
    isSearchBoxVisible: readonly(isSearchBoxVisible),
    setVisible,
  }
}
